import { render, staticRenderFns } from "./politicas.vue?vue&type=template&id=4c6ad91c&scoped=true"
import script from "./politicas.vue?vue&type=script&lang=js"
export * from "./politicas.vue?vue&type=script&lang=js"
import style0 from "./politicas.vue?vue&type=style&index=0&id=4c6ad91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ad91c",
  null
  
)

export default component.exports